import { CharacterFactory, type CharacterId } from "../characters";

const STORAGE_KEY = "goobijex:selectedCharacter";
const DEFAULT_CHARACTER: CharacterId = "warrior";

/**
 * Get the currently selected character from localStorage.
 * Returns the default character if none is saved or if the saved character is invalid.
 */
export function getSelectedCharacter(): CharacterId {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && CharacterFactory.has(stored as CharacterId)) {
      return stored as CharacterId;
    }
  } catch (error) {
    // localStorage might not be available (e.g., private browsing)
    console.warn("Could not read selected character from localStorage:", error);
  }
  return DEFAULT_CHARACTER;
}

/**
 * Save the selected character to localStorage.
 */
export function setSelectedCharacter(id: CharacterId): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch (error) {
    // localStorage might not be available (e.g., private browsing)
    console.warn("Could not save selected character to localStorage:", error);
  }
}
